const navLinks = [
  { label: '設備', href: '#equipment' },
  { label: '料金', href: '#pricing' },
  { label: 'アクセス', href: '#access' },
  { label: 'ルール', href: '#rules' },
];

function scrollTo(href: string) {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

export default function Footer() {
  return (
    <footer className="bg-[#050709]">
      {/* CTA Banner */}
      <div className="border-t border-[#2a2f3e] bg-[#0f1419]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-14 text-center">
          <p className="section-label mb-4 text-xs tracking-[0.4em]">BOOK NOW</p>
          <h2 className="font-playfair font-bold text-white text-2xl md:text-3xl mb-4">
            It&apos;s not about what you do, but who you do it with.
          </h2>
          <p className="text-white/50 font-noto text-sm mb-8 max-w-xs mx-auto leading-relaxed">
            スマートロックで24時間いつでも入室可能。
            <br />当日予約もOKです。
          </p>
          <a
            href="https://upnow.jp/duel"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-10 py-4 bg-[#d4af37] text-black font-bold text-base rounded-full hover:bg-[#e8c84a] hover:scale-105 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            今すぐ予約（登録不要）
          </a>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-10">
          {/* Logo & tagline */}
          <div className="text-center md:text-left">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="inline-block cursor-pointer"
            >
              <img
                src="https://public.readdy.ai/ai/img_res/aeba4ab0-d08d-4f57-aa37-c2ca8662af34.png"
                alt="デュエル ロゴ"
                className="h-12 w-auto"
              />
            </a>
            <p className="text-white/40 text-xs font-noto mt-3 leading-relaxed">
              秋葉原・神田エリアの本格
              <br />
              ポーカー&amp;ボードゲームスペース
            </p>
            <div className="flex items-center gap-2 mt-4 justify-center md:justify-start">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
              <span className="text-white/40 text-xs font-noto">24時間営業中</span>
            </div>
          </div>

          {/* Nav */}
          <nav className="flex flex-col items-center md:items-start gap-3">
            <p className="text-white/30 text-xs font-noto tracking-widest uppercase mb-1">
              メニュー
            </p>
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(link.href);
                }}
                className="text-white/50 hover:text-[#d4af37] text-sm font-noto transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <p className="text-white/30 text-xs font-noto tracking-widest uppercase mb-1">
              お問い合わせ
            </p>
            <a
              href="mailto:pokerrentalduel@gmail.com"
              className="flex items-center gap-2 text-white/50 hover:text-[#d4af37] text-sm font-noto transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line text-[#d4af37] text-sm" />
              pokerrentalduel@gmail.com
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#1a1f2e] mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/25 text-xs font-noto">
            &copy; 2025 ポーカーレンタルスペース デュエル. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              rel="nofollow"
              className="text-white/25 hover:text-white/50 text-xs font-noto transition-colors cursor-pointer whitespace-nowrap"
            >
              プライバシーポリシー
            </a>
            <a
              href="#"
              rel="nofollow"
              className="text-white/25 hover:text-white/50 text-xs font-noto transition-colors cursor-pointer whitespace-nowrap"
            >
              特定商取引法
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
